import { i18nActions } from './actionTypes';

const setI18n = payload => ({
  type : i18nActions.SET_I18N,
  payload
});

export { setI18n };
